export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
export const baseUrl = 'https://agpuat.digitalindiacorporation.in/agp/index.php/wp-json';
export const contentUrl = 'https://agpuat.digitalindiacorporation.in/agp/';
export const config = {
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'Authorization': (userData.token ? 'Bearer ' + userData?.token : ''),
  }
};